
import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows } from "./section-loan-property-allocations-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanPropertyAllocation extends Component {
  drawDataPropertyAllocation(data) {
    if (data.properties.length > 0) {
      return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;
    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Property Allocations",
            key: LOAN_SECTION_KEYS.PROPERTY_ALLOCATIONS,
            isExpandable: true,
            isTitleGroup: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.PROPERTY_ALLOCATIONS}`),
            sections: [
              this.drawDataPropertyAllocation(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.propertyallocations.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
